module.exports = __webpack_public_path__ + "static/media/ford-auth-lo.7f59be64.png";